var _regeneratorRuntime = require("/codebuild/output/src538327727/src/actions-runner/_work/www-lwb-org-au/www-lwb-org-au/node_modules/@babel/runtime/regenerator/index.js");
var _asyncToGenerator = require("/codebuild/output/src538327727/src/actions-runner/_work/www-lwb-org-au/www-lwb-org-au/node_modules/@babel/runtime/helpers/asyncToGenerator.js");
Object.defineProperty(exports, Symbol.toStringTag, {
  value: 'Module'
});
var core = require('@sentry/core');

/**
 * A function to diagnose why the SDK might not be successfully sending data.
 *
 * Possible return values wrapped in a Promise:
 * - `"no-client-active"` - There was no active client when the function was called. This possibly means that the SDK was not initialized yet.
 * - `"sentry-unreachable"` - The Sentry SaaS servers were not reachable. This likely means that there is an ad blocker active on the page or that there are other connection issues.
 *
 * If the function doesn't detect an issue it resolves to `undefined`.
 */
function diagnoseSdkConnectivity() {
  return _diagnoseSdkConnectivity.apply(this, arguments);
}
function _diagnoseSdkConnectivity() {
  _diagnoseSdkConnectivity = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var client;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          client = core.getClient();
          if (client) {
            _context.next = 3;
            break;
          }
          return _context.abrupt("return", 'no-client-active');
        case 3:
          if (client.getDsn()) {
            _context.next = 5;
            break;
          }
          return _context.abrupt("return", 'no-dsn-configured');
        case 5:
          _context.prev = 5;
          _context.next = 8;
          return fetch(
          // We want this to be as close as possible to an actual ingest URL so that ad blockers will actually block the request
          // We are using the "sentry-sdks" org with id 447951 not to pollute any actual organizations.
          'https://o447951.ingest.sentry.io/api/1337/envelope/?sentry_version=7&sentry_key=1337&sentry_client=sentry.javascript.browser%2F1.33.7', {
            body: '{}',
            method: 'POST',
            mode: 'cors',
            credentials: 'omit'
          });
        case 8:
          _context.next = 13;
          break;
        case 10:
          _context.prev = 10;
          _context.t0 = _context["catch"](5);
          return _context.abrupt("return", 'sentry-unreachable');
        case 13:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[5, 10]]);
  }));
  return _diagnoseSdkConnectivity.apply(this, arguments);
}
exports.diagnoseSdkConnectivity = diagnoseSdkConnectivity;